<template>
  <div class="container">
    <div class="school-body-index">
      <el-row>
        <el-col :span="24">
          <div class="classheader">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item
                @click.native="$router.back()"
                class="breadcrumb-item-back"
                >返回</el-breadcrumb-item
              >
              <el-breadcrumb-item>我的课程</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
      <el-form
        style="margin-top: 10px"
        :inline="true"
        size="mini"
        @submit.native.prevent
      >
        <el-form-item label="讲次名称:">
          <el-input
            clearable
            style="width: 200px"
            v-model="teachplan_form.title"
            placeholder="请输入讲次名称"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="search" icon="el-icon-search"
              >查询
            </el-button>
            <el-button
              type="primary"
              @click="ChangeSearchState"
              :icon="moresearch ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"
            ></el-button>
          </el-button-group> </el-form-item
        ><br />
        <el-form-item v-show="moresearch" label="上课时间:">
          <el-date-picker
            v-model="teachplan_form.date"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            value-format="yyyy-MM-dd"
            @change="changeTime"
            clearable
            placement="bottom-start"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="签到状态:" v-show="moresearch">
          <el-radio-group
            v-model="teachplan_form.state_for_search"
            @change="search"
          >
            <el-radio label="">全部</el-radio>
            <el-radio label="3">出勤</el-radio>
            <el-radio label="1">缺勤</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <el-timeline>
        <el-timeline-item
          :timestamp="item.start_class_date.slice(0, 10)"
          placement="top"
          v-for="(item, index) in stuTchPlanList"
          :key="index"
        >
          <el-card>
            <el-row class="classlist_wrapper">
              <el-col :span="4">
                <div class="classlist-imgwrapper">
                  <el-image
                    v-if="item.class_covers"
                    class="classimg_wrapper_img"
                    :src="item.class_covers"
                    fit="fill"
                  >
                  </el-image>

                  <el-image
                    v-else
                    class="classimg_wrapper_img"
                    :src="item.lessionInfo.img_url"
                    fit="fill"
                  ></el-image>
                </div>
              </el-col>
              <el-col :span="14" style="padding-top: 20px">
                <div class="classlist-content">
                  <div class="classlist-content-title">
                    <span class="coursetitle">
                      {{ item.lessionInfo.title }}
                    </span>
                    <div style="display: inline-block">
                      <span style="margin-right: 10px;">
                        <el-tag
                          v-if="item.stuTchPlanInfo.sign_state === null"
                          type="info"
                          effect="dark"
                          size="mini"
                          >未点名</el-tag
                        >

                        <el-tag
                          v-if="item.stuTchPlanInfo.sign_state === 1"
                          effect="dark"
                          size="mini"
                          >出勤</el-tag
                        >
                        <el-tag
                          v-if="item.stuTchPlanInfo.sign_state === 2"
                          effect="dark"
                          size="mini"
                          type="danger"
                          >缺勤</el-tag
                        >
                      </span>
                      <span
                        v-if="
                          item.stuTchPlanInfo.sign_state != 1 &&
                            item.stuTchPlanInfo.sign_state != null
                        "
                      >
                        <el-tag
                          v-if="item.stuTchPlanInfo.xm_miss_state === 1"
                          effect="dark"
                          size="mini"
                          type="warning"
                          >待补课</el-tag
                        >
                        <el-tag
                          v-if="item.stuTchPlanInfo.xm_miss_state === 2"
                          effect="dark"
                          size="mini"
                          type="warning"
                          >补课中</el-tag
                        >
                        <el-tag
                          v-if="item.stuTchPlanInfo.xm_miss_state === 3"
                          effect="dark"
                          size="mini"
                          type="warning"
                          >标记已补</el-tag
                        >
                        <el-tag
                          v-if="item.stuTchPlanInfo.xm_miss_state === 4"
                          effect="dark"
                          size="mini"
                          type="warning"
                          >插班已补</el-tag
                        >
                      </span>
                    </div>
                  </div>

                  <div class="classlist-content-desc">
                    <span style="font-weight: bold">讲次介绍:</span>

                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.lessionInfo.desc"
                      placement="top-start"
                    >
                      <span style="margin-left: 5px"
                        >{{ item.lessionInfo.desc }}
                      </span>
                    </el-tooltip>
                  </div>

                  <div class="classlist-content-date">
                    <span style="font-weight: bold">班级名称:</span>
                    <span style="margin-left: 5px">{{
                      item.classInfo.name
                    }}</span>

                    <br />

                    <span class="el-icon-time">
                      {{
                        item.start_class_date
                          ? item.start_class_date.slice(10, 20)
                          : '暂无'
                      }}
                      -

                      {{
                        item.end_class_date
                          ? item.end_class_date.slice(10, 20)
                          : '暂无'
                      }}
                    </span>
                    <span
                      style="margin-left: 10px;"
                      v-if="item.stuTchPlanInfo.orgStuTchPlanInfo != undefined"
                    >
                      <el-tooltip placement="top"
                        >div
                        <div slot="content">
                          <div>
                            原班级名称：{{
                              item.stuTchPlanInfo.orgStuTchPlanInfo.techPlanInfo
                                .className
                            }}
                          </div>
                          <div style="margin-top: 10px;">
                            原上课时间：{{
                              item.stuTchPlanInfo.orgStuTchPlanInfo.techPlanInfo
                                .sign_date
                            }}
                            -
                            {{
                              item.stuTchPlanInfo.orgStuTchPlanInfo.techPlanInfo.end_class_date.slice(
                                10,
                                20
                              )
                            }}
                          </div>
                        </div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </span>
                    <br />
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="classlist-btn">
                  <el-button
                    type="primary"
                    style="width: 150px"
                    round
                    icon="el-icon-monitor"
                    @click="goSchool(item, index)"
                    >进入课堂</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-timeline-item>
      </el-timeline>

      <div class="pagination-style" v-if="stuTchPlanList.length > 0">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page_no"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 30, 50]"
          :total="total"
        >
        </el-pagination>
      </div>

      <div style="margin-top: 15%; text-align: center" v-if="total == 0">
        <svg
          t="1650608314598"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="8006"
          width="200"
          height="200"
        >
          <path
            d="M875.6 724c0 128.5-162.8 160-363.6 160s-363.6-31.5-363.6-160S311.2 418.6 512 418.6 875.6 595.5 875.6 724z"
            fill="#C7F1FF"
            p-id="8007"
          ></path>
          <path
            d="M613 760.5H255.3c-20.8 0-37.6-16.9-37.6-37.6v-466c0-20.8 16.9-37.6 37.6-37.6H613c20.8 0 37.6 16.9 37.6 37.6v466c0.1 20.8-16.8 37.6-37.6 37.6z"
            fill="#FFD500"
            p-id="8008"
          ></path>
          <path
            d="M549.1 360.9H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h235.2c11.8 0 21.4 9.6 21.4 21.4s-9.6 21.4-21.4 21.4zM495.6 467.8H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4s-9.7 21.4-21.5 21.4zM495.6 564.1H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4s-9.7 21.4-21.5 21.4zM495.6 660.3H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4s-9.7 21.4-21.5 21.4z"
            fill="#FFFFFF"
            p-id="8009"
          ></path>
          <path
            d="M755 844.7H402c-22.1 0-40-17.9-40-40V343.5c0-22.1 17.9-40 40-40h353c22.1 0 40 17.9 40 40v461.3c0 22-17.9 39.9-40 39.9z"
            fill="#00B1FF"
            p-id="8010"
          ></path>
          <path
            d="M531.4 762.6h-26.2c-5.9 0-10.7-4.7-10.9-10.5l-1.9-57.2c-0.4-0.1-0.7-0.2-1.1-0.2-3.1 11.1-6.2 22.2-9.4 33.3-2.8 9.9-5.8 19.7-8.3 29.7-1 4-2.7 5.6-7 5.5-9.3-0.3-18.5-0.1-28.8-0.1 0.6-2.9 1-5.2 1.6-7.4 12.2-44.4 24.6-88.8 36.7-133.2 2.5-9.2 10.9-15.3 20.5-15.3h8.3c5.8-0.1 10.6 4.5 11 10.3l3.3 57.8c0.3 0.1 0.5 0.2 0.8 0.2 1.1-3.4 2.2-6.7 3.2-10.1 4.8-17.2 9.6-34.4 14.1-51.7 1.2-4.8 3.1-7 8.4-6.7 4.5 0.2 9.1 0.2 13.8 0.2 7.2 0 12.5 6.8 10.6 13.8-2.6 9.6-5.1 18.8-7.8 28-0.4 1.4-2.7 2.6-4.4 3.3-13.1 5.3-21.9 14.6-25.8 28.2-4.8 16.9-9.4 33.9-13.5 51-2.9 11.9-1 22.5 11.3 28.7 0.5 0.1 0.6 1 1.5 2.4zM608.6 758.4l11.8-82.5c0.8-5.4 5.4-9.4 10.8-9.4h2.1c6.7 0 11.8 6 10.8 12.6l-6.2 38.6c0.3 0.1 0.7 0.2 1 0.3 5.6-14.3 11.6-28.5 16.7-42.9 2.5-6.9 5.7-10.6 13.6-9.3 4.3 0.7 8.7 0.1 13.6 0.1-2.9 17.5-5.6 34.4-8.4 51.2 0.2 0.1 0.5 0.1 0.7 0.2 5.7-14.3 11.8-28.4 16.9-43 2.5-7 6.1-9.6 13.3-8.6 4.5 0.6 9.2 0.1 14.8 0.1-0.9 2.7-1.4 4.7-2.1 6.6-10.6 26.7-21.4 53.5-31.9 80.2-1.5 3.9-3.4 5.8-7.9 5.5-4.2-0.2-8.4-0.2-12.7-0.2-6.7 0-11.8-5.9-10.9-12.4l4.1-28.1c-0.5-0.2-1-0.3-1.5-0.5-3 7.1-6.9 14-8.7 21.4-4 16.6-13.5 23.2-30.2 19.8-2.8-0.2-5.8 0.3-9.7 0.3z"
            fill="#FFFFFF"
            p-id="8011"
          ></path>
          <path
            d="M608.9 702.3c-0.9 5.2-5.5 9.1-10.8 9.1-8.8 0-17.2 0.1-25.5-0.1-4.5-0.1-6.6 1.2-7.5 5.7-1.4 7.2-3.7 14.2-5 21.4-0.4 2 1.1 4.3 1.8 6.4 2.4-1.2 6.1-1.8 7-3.7 1.5-3.2 2.7-6.6 3.8-10.1 2.3-7.5 9.4-12.4 17.2-12.4h0.3c7.5 0 12.8 7.4 10.3 14.4-3.9 11-10.9 19.6-19.7 24.8-23.6 14-52.3-8.5-46-35.3 3.7-15.8 8-31.5 13.9-46.6 7-17.8 35.4-25.3 52.7-16.7 7.7 3.9 12.3 10 11.3 18.7-1 8.3-2.4 16.3-3.8 24.4z m-37.6-8.1c7.1 2.2 10.7 0.6 11.1-6.4 0.1-2.4 1.4-4.8 1.3-7.1 0-2.1-1.1-4.2-1.8-6.3-2.1 1.5-5.3 2.6-6.2 4.6-1.9 4.6-2.9 9.7-4.4 15.2z"
            fill="#FFFFFF"
            p-id="8012"
          ></path>
          <path
            d="M698.8 414.4H463.6c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h235.2c11.8 0 21.4 9.6 21.4 21.4s-9.6 21.4-21.4 21.4z"
            fill="#0091F1"
            p-id="8013"
          ></path>
          <path
            d="M645.3 521.3H463.6c-11.8 0-21.4-9.6-21.4-21.4 0-11.8 9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4-0.1 11.8-9.7 21.4-21.5 21.4z"
            fill="#0091F1"
            p-id="8014"
          ></path>
        </svg>
        <br />
        <span>暂无课程</span>
      </div>
    </div>

    <el-dialog
      title="课程讲义"
      :visible.sync="dialogVisible"
      width="80%"
      top="5vh"
    >
      <div>
        <iframe style="width: 100%; height: 80vh" :src="stu_note_url"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  stuGetStuClassList,
  stuGetStuTimetableNew,
} from '@/api/classroom/student_api'

import { dateFormat } from '@/config/_filter'
import moment from 'moment'
export default {
  name: 'classlistIndexStu1More',
  data() {
    return {
      //日期快捷选择1
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const start = moment().format('YYYY-MM-DD')
              const end = moment().format('YYYY-MM-DD')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近一周',
            onClick(picker) {
              const start = moment()
                .day(moment().day() - 6)
                .format('YYYY-MM-DD')
              const end = moment().format('YYYY-MM-DD')
              console.log(start, 1234165)
              console.log(end, 1234165)

              picker.$emit('pick', [start, end])
            },
          },

          {
            text: '近一个月',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'months')
                .format('YYYY-MM-DD')
              const end = moment().format('YYYY-MM-DD')

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '近三个月',
            onClick(picker) {
              const start = moment()
                .subtract(3, 'months')
                .format('YYYY-MM-DD')
              const end = moment().format('YYYY-MM-DD')
              picker.$emit('pick', [start, end])
            },
          },

          {
            text: '近一年',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'years')
                .format('YYYY-MM-DD')
              const end = moment().format('YYYY-MM-DD')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '去年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year() - 1)
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD')
              const end = moment(
                moment()
                  .year(moment().year() - 1)
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      userSubject: [],
      classList: [],
      currentpage: 1,
      activeName: 'first',

      sizeForm: {
        teaching_type: '', //课程类型
        course_state: '', //班级状态
      },
      stuTchPlanList: [], //我的课表
      stu_note_url: '',
      dialogVisible: false,
      dialogFormVisible: false, //教师点评
      //我的课表页码
      page_no: 1,
      page_size: 10,
      total: 0,
      //学员出勤页码
      page_no1: 1,
      page_size1: 20,
      total1: 0,

      //查看评语
      work_title: '',
      workinfo: {},
      markform: {},
      work_url: '',

      course_time: [],
      moresearch: true,

      teachplan_form: {
        date: [],
        default_time: '', //默认搜索时间
        state_for_search: '', //签到状态
        latest: true,
      },
      item1: {},
      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,
      chapter: '',
    }
  },
  computed: {
    needWatObj() {
      return sessionStorage.setItem('stuMsg1', JSON.stringify(this.item1)) //深拷贝需要监听的对象数据
    },
  },
  watch: {
    $route: {
      handler(newRoute, oldRoute) {
        console.log('newRoute:', newRoute)
        console.log('oldRoute:', oldRoute)
        if (
          oldRoute.name === 'classlistIndexStu1' &&
          this.$route.query.start_date
        ) {
          const { start_date, end_date } = this.$route.query
          this.teachplan_form.date = [start_date, end_date]
          this.stuGetStuTimetableNew()
        }
      },
    },
    needWatObj: {
      deep: true,
      handler(newVal, oldVal) {
        console.log('已改变的值=>', newVal)
        console.log('改变前的值=>', oldVal)
      },
    },
  },

  mounted() {
    if (this.$route.query.start_date) {
      const { start_date, end_date } = this.$route.query
      this.teachplan_form.date = [start_date, end_date]
    } else {
      // let next7Day = moment().subtract(180, 'days').format('YYYY-MM-DD 00:00:00');
      // let tady = moment().format('YYYY-MM-DD 23:59:59');
      let next7Day = moment()
        .subtract(1, 'months')
        .format('YYYY-MM-DD 00:00:00')
      let tady = moment().format('YYYY-MM-DD 23:59:59')
      // let next7Day = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD 00:00:00');
      // let tady = moment(moment().week(moment().week()).endOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD 23:59:59');
      let teachLsit = []
      teachLsit.push(next7Day, tady)
      console.log(teachLsit, 789465)
      this.teachplan_form.date = teachLsit
      this.teachplan_form.date = []
      this.teachplan_form.date.push(next7Day, tady)
      console.log(this.teachplan_form.date, 789465)
      this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50
      this.frameHeight = this.frameWidth * 0.75 + 55

      this.scale = this.frameWidth / 480

      // this.teachplan_form.default_time = dateFormat(); //获得当前时间

      console.log('默认起始时间')
      console.log(this.teachplan_form.default_time)
    }
    // this.stuGetStuClassList();
    // setTimeout(this.stuGetStuTimetableNew(), 3000);
    this.stuGetStuTimetableNew()
  },

  methods: {
    //进入课堂
    goSchool(item, index) {
      this.item1 = item
      sessionStorage.setItem('stuMsg1', JSON.stringify(item))
      this.$router.push({
        name: 'stuDetails1',
        query: { index: index + 1 },
      })
    },
    //改变搜索条件
    ChangeSearchState() {
      this.moresearch = !this.moresearch
    },

    onSubmit() {
      console.log('submit!')
      console.log(this.sizeForm)
      console.log(this.currentpage)
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.stuGetStuTimetableNew()
    },
    handleSizeChange(size) {
      this.page_size = size
      this.page_no = 1
      this.stuGetStuTimetableNew()
    },
    handleCurrentChange1(val) {
      this.page_no1 = val
    },

    LatestCourse(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('最近课程')
      console.log(this.teachplan_form.latest)

      if (!this.teachplan_form.latest) {
        this.teachplan_form.default_time = dateFormat() //获得当前时间
        this.teachplan_form.date = []
      } else {
        this.teachplan_form.default_time = ''
      }
      this.page_no = 1
      this.stuGetStuTimetableNew()
    },

    //查看学生讲义
    LookNote(note_url) {
      this.stu_note_url = note_url
      this.dialogVisible = true
    },

    //学生班级列表
    stuGetStuClassList() {
      stuGetStuClassList({
        subject_id: '',
        end_class_state: 0,
        teaching_type: this.sizeForm.teaching_type,
        course_state: this.sizeForm.course_state,
        course_week: '',
        course_time: '',
      }).then((res) => {
        console.log('查询班级列表')
        console.log(res)
        this.userSubject = res.userSubject //用户科目
        this.classList = res.classlist //班级列表
      })
    },
    changeTime(val) {
      console.log(val, 78945563)
      let timeArr = []
      timeArr = val
      timeArr[0] = val[0] + ' 00:00:00'
      timeArr[1] = val[1] + ' 23:59:59'
      console.log(timeArr, 78945563)
      this.teachplan_form.date = timeArr
      this.search()
    },

    search() {
      this.page_no = 1
      this.stuGetStuTimetableNew()
    },

    //学生课表
    stuGetStuTimetableNew() {
      stuGetStuTimetableNew({
        title: this.teachplan_form.title,
        state_for_search: this.teachplan_form.state_for_search,
        start_date: this.teachplan_form.date ? this.teachplan_form.date[0] : '', // 开始时间
        end_date: this.teachplan_form.date ? this.teachplan_form.date[1] : '', // 结束时间
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询学生课表')
        console.log(res)
        this.stuTchPlanList = res.tchPlanList
        this.total = res.total
        this.stuTchPlanList.map((item, index) => {
          this.chapter = index + 1
        })
        this.stuTchPlanList.sort((prev, next) => {
          return (
            new Date(prev.start_class_date) < new Date(next.start_class_date)
          )
        })
      })
    },

    //上课创作
    CreateWork(item, plan_id, operate) {
      console.log('上课创作')
      console.log(item)
      console.log(plan_id)
      console.log(operate)

      if (item.subject_id == '1') {
        if (operate == '1') {
          //上课创作
          if (item.class_work_url) {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.class_work_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          } else {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.lessionInfo.teach_template_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          }
        } else if (operate == '2') {
          console.log('继续挑战-课堂模板')
          window.location.href =
            '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
            item.stuTchPlanInfo.classWorkInfo.work_url +
            '&plan_id=' +
            plan_id +
            '&operate=' +
            operate
        } else if (operate == '3') {
          console.log('重新挑战-课后作业')

          if (item.homework_work_url) {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.homework_work_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          } else {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.lessionInfo.home_template_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          }
        } else if (operate == '4') {
          console.log('继续挑战-课后作业')
          window.location.href =
            '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
            item.stuTchPlanInfo.homeWorkInfo.work_url +
            '&plan_id=' +
            plan_id +
            '&operate=' +
            operate
        }
      } else if (item.subject_id == '2') {
        window.location.href =
          '/scratch/course.html?plan_id=' + plan_id + '&operate=' + operate
      } else if (item.subject_id == '3') {
        this.$router.push({
          name: 'python_course',
          query: {
            type: '2',
            title: item.lessionInfo.title,
            plan_id: plan_id,
            operate: operate,
          },
          params: {
            lessionInfo: item.lessionInfo,
            stuTchPlanInfo: item.stuTchPlanInfo,
          },
        })
      }
    },

    handleClassClick(id) {
      console.log('班级ID')
      console.log(id)
      sessionStorage.setItem('class_id', id),
        this.$router.push({
          name: 'classlistDescStu',
          // query: {
          //   class_id: id,
          // },
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.txt {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.container {
  box-sizing: border-box;
  min-width: 1200px;
  height: calc(100vh - 60px);
  padding: 30px 20px 0px;
  background-color: #f8f9fb;
  .school-body-index {
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    // background: white;
    // background: firebrick;
    background: url('../../../../assets/image/stuUI/stuDetailBg2@2x.png') left
      top / 100% 100% no-repeat;
    border-radius: 20px;
    padding: 20px 40px 25px;

    // clip-path: polygon(
    //   0 0,
    //   70% 0,
    //   75% 60px,
    //   98% 80px,
    //   100% 100px,
    //   100% 100%,
    //   0 100%
    // );
    // &::after {
    //   content: '';
    //   position: absolute;
    //   top: 0;
    //   right: -96px;
    //   height: 100px;
    //   width: 100px;
    //   background: radial-gradient(circle at 0 0, transparent 100px, #f00 100px);
    //   z-index: 10;
    //   border-radius: 0 60px 0 0;
    //   transform-origin: center;
    //   transform: rotateY(180deg);
    // }
    .classheader {
      margin-bottom: 20px;
    }
    .el-timeline {
      flex: 1;
      overflow-y: auto;
      padding-right: 10px;
      /* 修改垂直滚动条 */
      &::-webkit-scrollbar {
        width: 8px; /* 修改宽度 */
      }

      /* 修改滚动条轨道背景色 */
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }

      /* 修改滚动条滑块颜色 */
      &::-webkit-scrollbar-thumb {
        border-radius: 5px; /* 修改滑块圆角 */
        background-color: #888;
      }

      /* 修改滚动条滑块悬停时的颜色 */
      &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
      }

      /* 修改滚动条滑块移动时的颜色 */
      &::-webkit-scrollbar-thumb:active {
        background-color: #333;
      }

      /* 修改滚动条滑块的圆角 */
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
      }
    }
    .classwrapper {
      overflow-y: scroll;
      background: white;

      .classtype {
        margin-top: 10px;
      }

      .classlist {
        border: 1px solid rgb(226, 226, 226);
        margin: 15px;
        border-radius: 5px;
        padding-bottom: 10px;

        .class_img {
          display: block;
          width: 100%;
          height: 0;
          padding-bottom: 69%;
          background-repeat: no-repeat;
          background-size: cover;
          border-radius: 5px 5px 0px 0px;

          .classimg {
            width: 100%;
            border-radius: 5px 5px 0px 0px;
          }
        }

        .class_room {
          margin-top: 10px;

          .classname {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 800;
            padding-left: 10px;
            font-size: 16px;
          }
        }

        .class_time {
          padding-left: 10px;
          line-height: 20px;
        }

        .class_num {
          padding-left: 10px;
          line-height: 20px;
        }
      }

      .pagesdiv {
        text-align: center;
        padding: 10px;
      }
    }

    .classlist_wrapper {
      .classlist-imgwrapper {
        .classimg_wrapper_img {
          width: 100%;
          border-radius: 5px;
          margin-top: 7%;
        }
      }

      .classlist-content {
        flex: 1;
        display: flex;
        flex-flow: column;

        .classlist-content-title {
          flex: 1;
          padding-left: 40px;
          font-weight: 500;
          line-height: 30px;

          .coursetitle {
            padding-right: 10px;
            font-weight: 600;
            font-size: 16px;
          }
        }

        .classlist-content-desc {
          flex: 1;

          line-height: 25px;
          padding-left: 40px;
          padding-right: 20px;

          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          .content_desc {
            margin-left: 10px;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
          }

          .content-desc {
            padding-right: 20px;
          }
        }

        .classlist-content-date {
          flex: 1;

          line-height: 30px;
          padding-left: 40px;
        }
      }

      .classlist-btn {
        text-align: center;
        margin-top: 18%;

        .drop_btn {
          margin-right: 20px;
        }

        .class_btn {
          margin-right: 20px;
        }
      }
    }
    .pagination-style {
      margin-top: 15px;
    }
  }
}
</style>
